import { render, staticRenderFns } from "./CouponGroupsList.vue?vue&type=template&id=38f60e3e&scoped=true"
import script from "./CouponGroupsList.vue?vue&type=script&lang=ts"
export * from "./CouponGroupsList.vue?vue&type=script&lang=ts"
import style0 from "./CouponGroupsList.vue?vue&type=style&index=0&id=38f60e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f60e3e",
  null
  
)

export default component.exports